import styled from "styled-components";

import { colorsPalettes, mixins, rgba } from "@similarweb/styles";

export const StyledReminderInner = styled.div`
    background-color: ${colorsPalettes.carbon["0"]};
    border-radius: 6px;
    box-shadow: 0 -2px 16px ${rgba(colorsPalettes.carbon["500"], 0.08)};
    cursor: default;
    display: flex;
    flex-direction: column;
    max-height: 100%;
    overflow: hidden;
    position: relative;
    transition: max-height 600ms ease-in-out;
`;

export const StyledHeader = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    padding: 20px 24px;
    position: relative;
`;

export const StyledDescription = styled.div`
    display: flex;
    padding: 16px 24px 24px 24px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
`;

export const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: right;
    gap: 4px;
    padding: 0 16px 16px 16px;
`;

export const StyledExpandableWrap = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 0;
    transition: opacity 600ms ease-in-out;
`;

export const StyledTitle = styled.span`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon["500"])};
    user-select: none;
    line-height: 20px;
`;
